import { SecretCodeEditorDictionary } from 'types/i18n';

export const secretCodeEditorDictionaryRu: SecretCodeEditorDictionary = {
  titleText: 'Изменить секретный код',
  secretCodeInputLabel: 'Секретный код',
  secretCodeInputViolationMallformed:
    'Код может состоять только из латинских букв и цифр',
  secretCodeInputViolationLength: 'Код должен состоять из 6 символов',
  submitActionText: 'Сохранить изменения',
  cancelActionText: 'Отмена',
};
